import { SessionKeyEnum } from '../../../Enumeration/SessionKeyEnum';
import { useResource } from '../../../Hooks/UseResource';

function WidgetResource() {
    const [resourceError, loading, getData, postData] = useResource();
    
    /** save the widget details */
    const saveWidget =(widgetDTO)=>{
        return postData( {url:'public/widget-save',data:widgetDTO});       
   }

       
    /** save the widget details */
    const saveWidgetToDraft =(widgetDTO,currentTabName,suppressSuccessToast)=>{
        return postData( {url:'public/widget-save-draft',params:{"currentTabName":currentTabName}, data:widgetDTO},suppressSuccessToast);       
   }

    /** save the widget details */
    const completeKYC =(widgetDTO)=>{
        return postData( {url:'public/complete-kyc',data :{
        "appKey": sessionStorage.getItem(SessionKeyEnum.AppKey),
        "widgetDTO":widgetDTO,
        "encryptedMode":sessionStorage.getItem(SessionKeyEnum.EncryptedMode),
        "profileId":sessionStorage.getItem(SessionKeyEnum.ProfileId), 
        "profileStatusType":sessionStorage.getItem(SessionKeyEnum.ProfileStatusType),
        "holderType":sessionStorage.getItem(SessionKeyEnum.HolderType)}});       
   }

    return [ saveWidget,saveWidgetToDraft,completeKYC]

}

export default WidgetResource